import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.css',
    imports: [RouterModule]
})
export class SettingsComponent {

    ngOnInit(): void {
     
    }
}
